import React from 'react';
import PropTypes from 'prop-types';
import ReactDatePicker from 'react-datepicker';
import classnames from 'classnames';
import moment from 'moment';
import { isMobile } from 'react-device-detect';

import CustomInputWithStyleguide from './custom_input_with_styleguide';
import DatePickerButton from './date_picker_button';

import './brzw_date_picker.scss';

const BrzwDatePicker = ({
  calendarClassName,
  children,
  className,
  customInput,
  dateFormat,
  error,
  futureOnly,
  inputClassName,
  label,
  onChange,
  placeholderText,
  refFunc,
  showTimeSelect,
  timeIntervals,
  useCustomMobileInput,
  utcOffset,
  withStyleguide,
  ...rest
}) => {
  const defaultDateFormat = showTimeSelect ? 'MMM D, YYYY @ h:mm A' : 'MMM D, YYYY';
  const placeholderDefaultText = showTimeSelect ? 'Add date and time...' : 'Add date...';
  const minDate = futureOnly ? moment() : null;
  const utcOffsetUse = utcOffset !== null ? utcOffset : moment().utcOffset() / 60;
  const inputPlaceholder = placeholderText || placeholderDefaultText;
  const inputType = withStyleguide ? (
    <CustomInputWithStyleguide label={label} error={error} />
  ) : null;
  const mobileInput = withStyleguide ? (
    <CustomInputWithStyleguide label={label} error={error} />
  ) : (
    <DatePickerButton placeholder={inputPlaceholder} />
  );
  const input = isMobile && useCustomMobileInput ? mobileInput : inputType;

  return (
    <div className={classnames('brzw-date-picker', className)}>
      <ReactDatePicker
        calendarClassName={calendarClassName}
        className={inputClassName}
        customInput={customInput || input}
        dateFormat={dateFormat || defaultDateFormat}
        disabledKeyboardNavigation
        fixedHeight
        minDate={minDate}
        nextMonthButtonLabel=""
        onChange={onChange}
        onSelect={onChange}
        placeholderText={inputPlaceholder}
        previousMonthButtonLabel=""
        showTimeSelect={showTimeSelect}
        timeIntervals={timeIntervals}
        utcOffset={utcOffsetUse}
        ref={refFunc}
        {...rest}
      >
        {children}
      </ReactDatePicker>
    </div>
  );
};

BrzwDatePicker.propTypes = {
  calendarClassName: PropTypes.string,
  children: PropTypes.shape({}),
  className: PropTypes.string,
  customInput: PropTypes.shape({}),
  dateFormat: PropTypes.string,
  error: PropTypes.bool,
  futureOnly: PropTypes.bool,
  inputClassName: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholderText: PropTypes.string,
  refFunc: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({})]),
  showTimeSelect: PropTypes.bool,
  timeIntervals: PropTypes.number,
  useCustomMobileInput: PropTypes.bool,
  utcOffset: PropTypes.number,
  withStyleguide: PropTypes.bool,
};

BrzwDatePicker.defaultProps = {
  calendarClassName: '',
  children: null,
  className: '',
  customInput: null,
  dateFormat: '',
  futureOnly: false,
  inputClassName: '',
  label: '',
  placeholderText: '',
  showTimeSelect: false,
  timeIntervals: 15,
  useCustomMobileInput: true,
  utcOffset: null,
  withStyleguide: false,
};

export default BrzwDatePicker;
